import * as React from "react";

function SvgExperimentsbyGrowthhackers(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 201.7 200.4"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <image
        width={1430}
        height={210}
        xlinkHref="26CBF11914DBC145.png"
        overflow="visible"
      />
    </svg>
  );
}

export default React.forwardRef(SvgExperimentsbyGrowthhackers);
